import React from 'react'
import {
    Box,
    Card,
    CardContent,
    Typography,
    makeStyles
} from '@material-ui/core'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { useSelector, useDispatch } from 'react-redux'
import { enqueueSnackbar } from 'web/src/app/root/actions'
import { fetchDeviceMoveHistory } from '../../api/device-api'
import { useQuery } from 'react-query'
import { Loading } from 'web/src/app/root/components/common'
import { compareDateStringsDesc } from '../../utils'
import { getFormattedDate } from 'web/src/utils'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import HistoryIcon from '../../../../assets/svg/icon-history.svg'

const useStyles = makeStyles(theme => ({
    card: {
        marginBottom: theme.spacing(2)
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.5)
    },
    cardContentTopBorder: {
        borderTop: `0.5px solid ${theme.grayLight}`
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.primary,
        fontWeight: 'bold'
    },
    leftSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginRight: theme.spacing(2),
        width: 200
    },
    rightSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: 220
    },
    deviceReportsCard: { borderRadius: theme.borderRadius10 },
    arrowIcon: {
        padding: 15
    },
    locationName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}))

export const DeviceMoveHistoryCard = ({ device }) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    const dispatch = useDispatch()

    const { data, isLoading } = useQuery(
        ['deviceMoveHistory', device.id],
        () => fetchDeviceMoveHistory(device.id),
        {
            refetchInterval: false,
            refetchOnWindowFocus: false,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.getDeviceHistoryEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )
    if (!data || data.length === 0) {
        return null
    }

    return (
        <Box>
            <NavLink
                className={classes.link}
                style={{ textDecoration: 'underline' }}
                to={`/devices/${device.id}/history`}
            >
                <Typography style={{ paddingBottom: 10 }}>
                    {locale.devices.history}
                </Typography>
            </NavLink>
            <Card style={{ width: 500 }} className={classes.deviceReportsCard}>
                {isLoading && <Loading />}
                {data
                    ?.sort(({ created_at: date1 }, { created_at: date2 }) =>
                        compareDateStringsDesc(date1, date2)
                    )
                    .slice(0, 3)
                    .map((move, index) => (
                        <CardContent
                            key={index}
                            className={classNames(classes.cardContent, {
                                [classes.cardContentTopBorder]: index != 0
                            })}
                        >
                            <Box className={classes.arrowIcon}>
                                <img src={HistoryIcon} alt="History icon" />
                            </Box>
                            <Box className={classes.leftSection}>
                                <Typography>
                                    {getFormattedDate(move.created_at)}
                                </Typography>
                                <Typography>{move.moved_by_name}</Typography>
                            </Box>
                            <Box className={classes.rightSection}>
                                <Typography>
                                    <strong>
                                        {locale.reports.filterFrom}:{' '}
                                    </strong>
                                    <span className={classes.locationName}>
                                        {move.location_from_name}
                                    </span>
                                </Typography>
                                <Typography>
                                    <strong>{locale.reports.filterTo}: </strong>
                                    <span className={classes.locationName}>
                                        {move.location_to_name}
                                    </span>
                                </Typography>
                            </Box>
                        </CardContent>
                    ))}
            </Card>
        </Box>
    )
}
